<template>
  <div class="content-warpper">
    <div class="warpper-title">
      <i class="iconfont iconbaoming"></i>
      学生详情
    </div>
    <div class="padding-sm flex align-center justify-around">
      <div class="volunteer-detail">
        <div class="border-bottom padding-sm">
          <span class="name">张坤</span>
          <span class=" padding-left font-size-lg">男</span>
          <span class=" padding-left font-size-lg">19</span>
          <span class=" padding-left font-size-lg">2020级1班</span>
          <span class=" padding-left font-size-lg">XX学校名称</span>
        </div>

        <div class="border-bottom padding-sm">
          <h2>学习课程:</h2>
          <div>《课程课程课程》  《课程课程课程》  《课程课程课程》  《课程课程课程》   《课程课程课程》  《课程课程课程》</div>
        </div>
        <div class="border-bottom padding-sm flex align-center">
          <h2>考试情况:</h2>
          <div class="padding-left font-size">考勤率：74%</div>
        </div>
        <div class="border-bottom padding-sm">
          <h2>期中考试成绩:</h2>
          <div class="font-size">课程：67分 <i class="padding-left"></i> 课程：67分  <i class="padding-left"></i> 课程：67分  <i class="padding-left"></i> 课程：67分</div>
        </div>
        <div class="border-bottom padding-sm">
          <h2 class="flex align-center justify-between">实习评价:
            <p>
              实习单位名称<br/>
              日期：2020年12月20日
            </p>
          </h2>
          <div>
            <p class="hals-color">实习导师姓名</p>
            <p>
              张坤同学在学习和过程中表现积极，在学习课程期间中对多重情况分析到位。张坤同学在学习和过程中表现积极，在学习课程期间中对多重情况分析到位。张坤同学在学 习和过程中表现积极，在学习课程期间中对多重情况分析到位。张坤同学在学习和过程中表现积极，在学习课程期间中对多重情况分析到位。
            </p>
          </div>
        </div>
        <div class="border-bottom padding-sm">
          <h2 class="flex align-center justify-between">老师评语:
            <p>
              日期：2020年12月20日
            </p>
          </h2>
          <div>
            <p class="hals-color">学校老师姓名</p>
            <p>
              张坤同学在学习和过程中表现积极，在学习课程期间中对多重情况分析到位。张坤同学在学习和过程中表现积极，在学习课程期间中对多重情况分析到位。张坤同学在学
              习和过程中表现积极，在学习课程期间中对多重情况分析到位。张坤同学在学习和过程中表现积极，在学习课程期间中对多重情况分析到位。
            </p>
          </div>
        </div>


      </div>
    </div>
  </div>
</template>

<script>


export default {
  name: "volunteerDetail",
  data() {
    return {};
  },
  created() {
    this.$emit(
        "setIndex",
        '/practiceBase/student',
        "当前位置：岗位管理 - 学生管理 - 学生详情",
        true
    );
  },
  methods: {}
}
</script>

<style scoped lang="scss">
.volunteer-detail {
  width: 80%;
  border: 1px dashed #999;

  .border-bottom {
    border-bottom: 1px dashed #999;
    .name{
      font-size: 28px;
      font-weight: bold;
      color: #009688;
    }
    h2 {
      font-size: 18px;
      line-height: 42px;
      color: #009688;
      p{
        font-size: 14px;
        color: #666;
        line-height: 30px;
        text-align: right;
        font-weight: normal;
      }
    }
    div{
      line-height: 200%;
      font-size: 16px;

      p{
        text-indent: 32px;
        &.hals-color{
          color: #009688;
          text-indent:0;
        }
      }
    }
  }
}
</style>